import React from 'react';

interface DocumentCardProps {
  title: string;
  pages: string;
  url: string;
}

/**
 * Renders a document card displaying document metadata.
 * Shows the title, number of pages, and a link to view the document.
 */
const DocumentCard: React.FC<DocumentCardProps> = ({ title, pages, url }) => {
  return (
    <div className="ves-document-card">
      <div className="ves-document-header">
        <h3 className="ves-document-title">{title}</h3>
      </div>
      <div className="ves-document-meta">
        <span className="ves-document-pages">{pages} pages</span>
      </div>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="ves-document-link"
      >
        View Document
      </a>
    </div>
  );
};

export default DocumentCard;
